<template>
  <div class="fts-automation-query-display">
    <div v-for="filter in items" :key="filter.id">
      <div class="query-condition" v-if="isParent(filter.type)">
        <div 
          class="query-condition-line"
          :class="{
            'query-condition-line--or': filter.type === 'or',
            'query-condition-line--not': filter.type === 'not'
          }"
        />
        <fts-automation-query-display 
          :items="filter.items"
          :information-source="informationSource"
          :state-source="stateSource"
          class="query-condition-filter" />
      </div>
      <div class="query-filter" v-else>
        <div class="query-filter__label">{{(filter.fieldName)}}&nbsp;</div>
        <div>{{filter.operator}}&nbsp;</div>
        <div>
          <fts-state 
            :state="filter.payload" 
            :options="stateSource" 
            v-if="filter.fieldName === 'state' && filter.system" />
          <div v-else>payload/formula-display</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FTSState from "../../elements/FTSState";

export default {
  name: "fts-automation-query-display",
  props: {
    items: Array,
    informationSource: Array,
    stateSource: Array,
  },
  components: {
    "fts-state": FTSState,
  },
  methods: {
    isParent(type) {
      return ['and', 'or', 'not'].indexOf(type) > -1;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-automation-query-display {
  .query-condition {
    position: relative;
    .query-condition-line {
      position: absolute;
      height: 100%;
      width: .15rem;
      left: .15rem;
      border-radius: 10em;
      background: $primaryColor;
      &.query-condition-line--or {
        background: $secondaryColor;
      }
      &.query-condition-line--not {
        background: $dangerColor;
      }
    }
    .query-condition-filter {
      margin-left: 1rem;
    }
  }
  .query-filter {
    display: flex;
    align-items: center;
    margin-bottom: .75rem;
    .query-filter__label {
      font-weight: 700;
    }
  }
}
</style>